import { useEffect, useState } from 'react';
import UserHistory from '../../../../domain/models/user_doc/UserHistory';
import { HistoryEntryType } from '@leedpulse-monorepo/enums';
import getUsersByConstraints from '../../../../domain/use_cases/users/getUsersByConstraints';

interface UserHistoryDetailsProps {
    userHistory: UserHistory;
}

export default function UserHistoryDetails({ userHistory }: UserHistoryDetailsProps) {
    const [details, setDetails] = useState<string>(
        userHistory.type === HistoryEntryType.email ||
            userHistory.type === HistoryEntryType.sms ||
            userHistory.type === HistoryEntryType.push ? userHistory.external_id || '-' : '-'
    );

    useEffect(() => {
        const loadDetails = async () => {
            if (
                userHistory.type === HistoryEntryType.email ||
                userHistory.type === HistoryEntryType.sms ||
                userHistory.type === HistoryEntryType.push
            ) {
                setDetails(userHistory.external_id || '-');
                return;
            }
            if (userHistory.type === HistoryEntryType.login && userHistory.adminUid) {
                const adminUser = await getUsersByConstraints([
                    { field: 'uid', op: '==', value: userHistory.adminUid as string },
                ]);
                setDetails(
                    adminUser.length > 0
                        ? `${adminUser[0].firstname} ${adminUser[0].lastname} (${adminUser[0].email}) s'est connecté`
                        : '-'
                );
                return;
            }
            setDetails('-');
        };

        loadDetails();
    }, [userHistory]);

    return details;
}